<template>
    <tr>
        <!-- <td><b class="font-weight-bold">{{new Date(item.date).toLocaleDateString("en-IN")}}</b></td> -->
        <td><b class="font-weight-bold">{{new Date(item.closedDate ? item.closedDate : item.date).toLocaleDateString('en-IN')}}</b></td>
        <!-- <td><b class="font-weight-bold">{{new Date(item.date).toLocaleDateString('en-IN')}}</b></td> -->
        <td><b class="font-weight-bold" v-if="item.buyerId">{{buyerById(item.buyerId)['name']}} </b></td>
        <template>    
        <td> <b class="green--text font-weight-bold"> {{getCredit(item) || 0 | amount}} </b></td>        
        <td> <b class="red--text font-weight-bold"> {{getDebit(item)|| 0 | amount }} </b></td>
        </template>
        <td><b class="font-weight-bold">{{getVocherType(item)}} </b></td>
        <td><b class="font-weight-bold">{{item.paymentType}}</b></td>
        <td><b class="font-weight-bold">{{item.status}}</b></td>
        <td ><b class="font-weight-bold"> {{item.remark}} </b></td>
    </tr>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']

import {DateTime, Interval} from 'luxon'

    export default {
        props:{
            item:{
                type:Object,
                default: () => {
                    return {}
                }
            },
            isCredited: {
                type: Boolean,
                default: true
            }, 
            firms: {
                type: Array,
                default: []
            },  
            sellers: {
            type: Object,
                default: []
            },
            buyers: {
                type: Object,
                default: []
            },
            status: {
                type: Array,
                default: () => {
                    return ['close']
                }
            },
            firmAssignment: {
                type: Boolean,
                default: false
            },
            heading: {
                type: String,
                default: ""
            },
            selectedFirm: {
                type: String,
                default: null
            },
            selectedDate: {
                type: String,
                default: () => {
                let today = new Date()
                return `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}` 
                }
            }
        },
        data: () => ({
        }),
        computed:{
            ...mapGlobalGetters(['selectedBrand']),
            firmsByBrand () {
            return this.firms.filter((item) => 
                item['brand'] === this.selectedBrand
            )
        }
        },
        methods: {
            buyerById (id) {
                if (this.buyers[id]) {
                    return this.buyers[id]
                } else if (this.sellers[id]) {
                    return this.sellers[id]
                } else {
                    return {
                        name : '--'
                    }
                }
            },
            getCredit(item){
                if(item.status == 'Bank Opening Balance') {
                    return 0
                }
                if(('Opening Balance' == item.type  && item.status == 'paid') ||  ('Opening Balance' == item.type  && item.status == 'partial')) {
                    return !item.isBuyer? item['settledAmount'] : 0
                }
                if(item.type =='CustomerPayment') {
                    if (item.isBuyer) {
                    return 0;
                    } else {
                    return item['remainingAmount'];
                    }
                } 
                else if( !item.isBuyer && ('Advance' == item.type || 'Security' ==  item.type)) {
                   return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
                }
                if(item.isBuyer) {
                    switch(item.status) {
                        case 'due' : {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                        case 'paid' : {
                            return 0;
                            break;
                        }
                        case 'partial' : {
                            return 0;
                            break;
                        }
                    }
                } else {
                     switch(item.status) {
                        case 'due' : {
                            return  item.settledAmount || 0
                            break;
                        }
                        case 'paid' : {
                            return (Number.parseFloat(item['amountFromBank']));
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                        case 'partial' : {
                            return (Number.parseFloat(item['amountFromBank']));
                            // return Number.parseFloat(item['paidAmount']);
                            break;
                        }
                    }
                }
            },
            getDebit(item){
                if(item.status == 'Bank Opening Balance') {
                    return item.openingBalance
                }
                if(('Opening Balance' == item.type  && item.status == 'paid') ||  ('Opening Balance' == item.type  && item.status == 'partial')) {
                    return item.isBuyer? item['settledAmount'] : 0
                }
                                
                if(item.type =='CustomerPayment') {
                    if (!item.isBuyer) {
                    return 0;
                    } else {
                    return item['remainingAmount'];
                    }
                } 
                else if( item.isBuyer && ('Advance' == item.type || 'Security' ==  item.type)) {
                   return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
                }
                if(item.isBuyer) {
                    switch(item.status) {
                        case 'due' : {
                            return item.settledAmount || 0;
                            break;
                        }
                        case 'paid' : {
                            return (Number.parseFloat(item['amountFromBank']));
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                        case 'partial' : {
                            return (Number.parseFloat(item['amountFromBank']));
                            break;
                        }
                    }
                } else {
                     switch(item.status) {
                        case 'due' : {
                            return item.totalAmount || item.amount || 0
                            break;
                        }
                        case 'paid' : {
                            return 0;
                            break;
                        }
                        case 'partial' : {
                            return 0;
                            break;
                        }
                    }
                }
            },
            firmNameById (id) {
                let firm = this.firms.filter(item=> item['.key'] == id)[0]
                if (firm) {
                    return firm['name']
                }
            },
            getNumberOfDaysFromStartDate (createdAt, closedDate) {
                console.log (createdAt, closedDate)
                const startDate = DateTime.fromMillis(createdAt)
                if(!closedDate) {
                    closedDate = DateTime.local()
                } else {
                    closedDate = DateTime.fromMillis(closedDate)
                }
                const endDate = closedDate
                const interval = Interval.fromDateTimes(startDate, endDate)
                return Number.parseInt(interval.length('days'))
            },
            getTotalAmount (principal, rate, createdAt) {
                const time = this.getNumberOfDaysFromStartDate(createdAt) / 365
                rate = rate * 12 / 100
                return Number.parseFloat(principal * (1 + (rate * time))).toFixed(2)
            },
            getInterestValue (principal, rate, createdAt) {
                return (this.getTotalAmount(principal, rate, createdAt) - Number.parseFloat(principal)).toFixed(2)
            },
            getVocherType(invoice) {
              if(invoice.status == 'Bank Opening Balance') {
                return 'Bank Opening Balance'
              }
              if(invoice.type == 'CustomerPayment') {
                if (invoice.isBuyer) {
                return "Receipt";
                } else {
                return "Payment";
                }
            }
            if (invoice.return) {
                if (invoice.isBuyer) {
                return "Credit Note";
                } else {
                return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (
                invoice["type"] == "automatic invoice" &&
                invoice.transactionType === "Transfer"
            ) {
                return "Transfer";
            } 
            else if (
                (invoice.transactionType != "Debit" && invoice["type"] === "Advance") ||
                // invoice["type"] === "Opening Balance" ||
                invoice["type"] === "LoanGiven" || 
                invoice["type"] === "LoanTaken" ||
                invoice["type"] === "Security"
            ) {
                return invoice["type"];
            }
            else if ( invoice["type"] === "Opening Balance" && !invoice["settledAmount"]  ) {
                return "Opening Balance"
            }
            else if ( invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]  ) {
                return "Receipt"
            } 
            else if ( !invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]  ) {
                return "Payment"
            } 
            else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } 
            else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            }
            else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/BankStatements/normalInvoice.vue